import createEnhancedAsynThunk from '../../utils/createEnhancedAsynThunk';
import sliceHandler from '../../utils/sliceHandler';

const sliceArgs = {
  SLICE_NAME: 'menu',
  ENDPOINT: 'venues',
  RESOURCE: 'menu',
};

const sliceName = sliceArgs.SLICE_NAME;

const fetchMenu = createEnhancedAsynThunk({
  name: sliceArgs.SLICE_NAME,
  endpoint: sliceArgs.ENDPOINT,
  resource: sliceArgs.RESOURCE,
  method: 'GET',
  version: 'v2',
});

const fetchBrandMenu = createEnhancedAsynThunk({
  name: sliceArgs.SLICE_NAME,
  endpoint: 'brands',
  resource: 'menu-preview',
  method: 'GET',
  version: 'v2',
  paramsTransformer: (brandMenuId) => `menus/${brandMenuId}`,
});

const fetchVenueMenu = createEnhancedAsynThunk({
  name: sliceArgs.SLICE_NAME,
  endpoint: 'venues',
  resource: 'menu-preview',
  method: 'GET',
  paramsTransformer: ({ venueId, menuName }) => `${venueId}/menus/${menuName}`,
});

const extraReducers = [fetchMenu, fetchBrandMenu, fetchVenueMenu];

const slice = sliceHandler({ sliceName, extraReducers });
const { reducer } = slice;

export { fetchMenu, fetchBrandMenu, fetchVenueMenu };
export default reducer;
